module.exports = __webpack_public_path__ + "img/番外_学电视剧_01_开场.a09c2cfd.png";